<template>
      <li class="prj_item" :class="{ 'active':$route.path=='/apply' , 'in_my_page':$route.path=='/mypage/bidding' }" >
            <div class="prjct-info">
              <div class="prjct-info-title">
                <span
                  class="ellipsis prjct-info-title-txt projectInfo"
                  data-pno="28710"
                  @click="$router.push(`/apply?id=${item.id}`)"
                >{{item.title}}</span>
                
                <div v-if="item.gap >= 0" class="prjct-state tooltip-container" data-pno="28710">                    
                    제안중                    
                </div>
                <div v-else class="prjct-state tooltip-container" data-pno="28710">                    
                    제안종료                   
                </div>
                
                <div class="prjct-state new tooltip-container" style="margin-left: 1px;">NEW</div>
                <span class="prjct-date">등록일 : {{item.created_at.split("T")[0]}}</span>
              </div>
              <div class="prjct-info-container">
                <div class="prjct-info-left">
                  <ul>
                    <li>
                      <div class="prjct-label">예상비용</div>
                      <div class="prjct-content font-gray">{{ price_choice[item.finance_range][1] }}</div>
                    </li>
                    <li>
                      <div class="prjct-label prjct-label-period">작업기간</div>
                      <div class="prjct-content">
                        {{ period_choice[item.period_range][1] }}                         
                      </div>
                    </li>
                    <li>
                      <div class="prjct-label prjct-label-deadline">마감</div>
                      <div class="prjct-content">
                        {{ item.gap }}일
                      </div>
                    </li>
                  </ul>
                  <div class="prjct-label">지원자 수</div>
                  <div class="prjct-content prjct-volunteer">
                    <span class="prjct-volunteer-num">{{item.applier_count}}</span> 명
                  </div>
                </div>
                <div class="prjct-info-right">
                  <!-- <div class="prjct-info-type" style="line-height: 15px;">
                    개발 &gt;
                    <span class="prjct-info-type-bold">웹</span>
                  </div>
                  <div class="prjct-info-tech">JAVA,JSP,LINUX</div> -->
                  <div class="prjct-info-txt is-truncated" style="overflow-wrap: break-word;">
                    {{item.content}}
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <div class="prjct-about" v-if="$route.path != '/mypage/bidding'">
              <div class="prjct-about-top">
                <div class="prjct-about-top-title">
                  <img
                    class="prjct-about-top-image"
                    src="http://pic.freemoa.net/u/42472/15719-36-36-1"
                  >
                  <span class="font-bold">{{ item.author_name }}</span>
                  <span class="prjct-about-bar">|</span> 서울
                </div>
                <pre
                  class="prjct-about-top-content is-truncated"
                  style="overflow-wrap: break-word;"
                >㈜신도테크노는 1989년 4월... </pre>
                <span class="prjct-about-top-badge badge-escrow on tooltip-container">
                  에스크로
                  <span class="tooltiptext">프리모아의 대금보호 서비스를 이용합니다.</span>
                </span>
                <span
                  class="prjct-about-top-badge badge-projectpm"
                  style="font-size: 10px;line-height: 10px;"
                >
                  NDA
                  <br>비밀유지서약
                  <span class="tooltiptext tooltiptext-left">클라이언트가 제공하는 정보에 대해 보안서약서를 작성합니다.</span>
                </span>
              </div>
              <div class="prjct-history display-none">
                <div class="prjct-history-title">진행내역</div>
                <ul>
                  <li>
                    <div class="prjct-label">등록</div>
                    <div class="prjct-content">1건(신규등록)</div>
                  </li>
                  <li>
                    <div class="prjct-label">계약</div>
                    <div class="prjct-content">1건(신규등록)</div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="clear"></div>
            <div @click="toggle_detail($event)" v-if="$route.path=='/apply'" class="detail-btn-wrap"><div class="prjct-detail-btn">프로젝트 내용 보기</div></div>
            <div class="detail-content hidden"  v-if="$route.path=='/apply'" >
              <div class="html-area">{{item.content}}</div>
              <div>첨부파일 : <a target="_blank" :href="src + item.file">{{item.file}}</a></div>
            </div>
          </li>                                                                      
</template>

<script>
export default {
  props:["item","price_choice","period_choice"],
  methods:{
      toggle_detail(e){
        $(e.target).closest(".prj_item").find(".detail-content").toggleClass("hidden")
        if( $(e.target).closest(".prj_item").find(".detail-content").hasClass("hidden")  ){ $(e.target).closest(".prj_item").find(".prjct-detail-btn").text("프로젝트 내용 보기")   }
        else{ $(e.target).closest(".prj_item").find(".prjct-detail-btn").text("프로젝트 내용 닫기")   }
      }
  },
  computed:{

  },
  data(){
    return{
        
    }
  },
  mounted(){
    console.log(this.item)
  }
};
</script>

<style scoped lang="scss">
.in_my_page{
  width:740px!important;
  .prjct-info{
    width: 710px!important;
  }
  .prjct-info-right{
    width: 400px!important;
  }
}
  .prj_item {
    width: 1110px;
    padding: 16px 16px 15px 26px;
    letter-spacing: 0;
    background: #fff;
    border: 1px solid #ddd;
    margin-bottom: 10px;
    position: relative;
    word-spacing: 0;
    font-size: 0;
    &:hover, &.active{
        border: 1px solid #f27925;
    }
    .detail-content{
      margin-top: 10px;
      display: inline-block;
      width: 100%;
      border: 1px solid #ddd;
      padding: 20px 0 10px 20px;
      height: 100%;
      overflow: auto;
      vertical-align: top;
      white-space: pre-line;
      box-sizing: border-box;
      font-size: 12px;
      height:100px;
      overflow-y: scroll;
    }
    .detail-btn-wrap{
      color:#fff;
      width: 140px;
      height: 30px;
      background-color: #fe7c25;      
      font-size: 13px;
      text-align: center;
      line-height: 30px;
      display: inline-block;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translate(-50%,0);
      border-radius: 0 0 7px 7px;
      cursor: pointer;
      .prjct-detail-btn{
        color:#fff;
      }
      .prjct-detail-btn:before {
          content: '';
          position: absolute;
          top: 0;
          left: -7.3px;
          border-top: 26px solid #fe7c25;
          border-left: 8px solid transparent;
      }
      .prjct-detail-btn:after {
          content: '';
          position: absolute;
          top: 0;
          right: -7.9px;
          border-top: 26px solid #fe7c25;
          border-right: 8px solid transparent;
      }
    }
    .prjct-info {
      width: 765px;
      padding-right: 20px;
      display: inline-block;
      vertical-align: middle;
      .prjct-info-title {
        font-size: 20px;
        color: #373737;
        display: block;
        margin-bottom: 24px;
        margin-top: 5px;
        .prjct-info-title-txt {
          font-weight: bold;
          max-width: 430px;
          margin-right: 10px;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .star {
          background: url(/public/images/dgm/sortRecruitBg-star.png) 0 0
            no-repeat;
          width: 25px;
          height: 25px;
          margin-top: 2px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 7px;
        }
        .haslookprj {
          color: #aaa;
        }
        .prjct-state {
          display: inline-block;
          font-size: 11px;
          color: #fff;
          background: #f3a122;
          vertical-align: middle;
          padding: 2px 8px;
        }
        .prjct-date {
          color: #b0b0b0;
          float: right;
          font-size: 12px;
          line-height: 1;
          margin-top: 12px;
        }
      }
    }
    .prjct-info-container {
      position: relative;
      .prjct-info-left {
        width: 255px;
        float: left;
        ul {
          border-bottom: 1px solid #949494;
          margin-bottom: 9px;
          li {
            font-size: 0;
            letter-spacing: 0;
            word-spacing: 0;
            margin-bottom: 7px;
            .prjct-label {
              display: inline-block;
              width: 70px;
              font-size: 12px;
              color: #373737;
              vertical-align: middle;
            }
            .prjct-content {
              display: inline-block;
              vertical-align: middle;
              color: #8c8c8c;
              width: 185px;
              font-weight: bold;
              font-size: 16px;
            }
          }
        }
        .prjct-label {
          display: inline-block;
          width: 70px;
          font-size: 12px;
          color: #373737;
          vertical-align: unset;
        }
        .prjct-volunteer {
          font-weight: normal;
          background: none;
          color: #373737;
          padding: 0 0;
          margin-top: 0;
          display: inline-block;
          font-size: 13px;
          .prjct-volunteer-num {
            font-size: 15px;
            font-weight: bold;
            color: #f27824;
          }
        }
      }
      .prjct-info-right {
        width: 456px;
        padding-left: 25px;
        margin-left: 28px;
        border-left: 1px solid #eaeaea;
        margin-bottom: 7px;
        float: left;
        height:119px;
        .prjct-info-type {
          padding: 3.5px 7px;
          margin-bottom: 13px;

          display: inline-block;
          border: 1px solid #f27824;
          color: #f27824;
          font-size: 12px;
          line-height: 1;
          border-radius: 3px;
        }
        .prjct-info-tech {
          margin-bottom: 11px;
          color: #f27824;
          font-size: 13px;
          line-height: 1;
          word-spacing: 5px;
        }
        .prjct-info-txt {
          color: #8c8c8c;
          margin-bottom: 0;
          line-height: 21px;
          font-size: 13px;
        }
      }
    }
    .prjct-info-container:before {
      left: 283px;
      content: "";
      background: #eaeaea;
      width: 1px;
      height: 100%;
      display: inline-block;
      position: absolute;
      top: 0;
    }
    .prjct-about {
      width: 249px;
      border: 1px solid #eee;
      background: #fcfcfc;
      display: inline-block;
      vertical-align: middle;
      box-sizing: border-box;
      .prjct-about-top {
        padding: 18px 10px 12px 22px;
        border-bottom: 0;
        color: #8c8c8c;
        .prjct-about-top-title {
          margin-bottom: 18.5px;
          line-height: 1;
          font-size: 13px;
          color: #373737;
        }
      }
      .prjct-about-top-image {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
        margin-bottom: 4px;
        border-radius: 100%;
        width: 36px;
        height: 36px;
      }
      .font-bold {
        font-weight: bold !important;
      }
      .prjct-about-bar {
        color: #b7b7b7;
      }
      .prjct-about-top-content {
        min-height: 50px;
        font-size: 13px;
        margin-bottom: 10px;
      }
      .badge-escrow.on {
        background: url(http://www.freemoa.net/public/images/dgm/badge-escrow-on.png)
          no-repeat center 24px;
        background-color: #f3a122;
        border-color: #f3a122;
      }
      .badge-projectpm {
        background: url(http://www.freemoa.net/public/images/dgm/badge-projectpm.png)
          no-repeat center 24px;
        font-size: 11px;
        color: #a5a5a5;
        display: inline-block;
        vertical-align: middle;
        width: 67px;
        height: 55px;
        text-align: center;
        border-radius: 3px;
        box-sizing: border-box;
        padding-top: 2px;
        padding-right: 4px;
        padding-left: 4px;
        border: 1px solid #d9d9d9;
        background-color: #f5f5f5;
        margin-right: 6px;
      }
      .tooltiptext {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/SPA/Search/Components/BiddingItem.vue